import type { Tone } from '@quill/shared';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ThemeMode = 'dark' | 'light';

type SettingsState = {
  helperName: string;
  defaultTone: Tone;
  theme: ThemeMode;
  setHelperName: (name: string) => void;
  setDefaultTone: (tone: Tone) => void;
  setTheme: (theme: ThemeMode) => void;
};

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      helperName: 'Quill',
      defaultTone: 'friendly',
      theme: 'dark',
      setHelperName: (helperName) => set({ helperName }),
      setDefaultTone: (defaultTone) => set({ defaultTone }),
      setTheme: (theme) => set({ theme }),
    }),
    { name: 'quill.settings' },
  ),
);
